import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 'hero_platform', label: 'Platform' },
    { value: 'hero_ios_data', label: 'iOS Data' },
    { value: 'hero_ios_tokens', label: 'iOS Tokens' },
    { value: 'hero_android_data', label: 'Android Data' },
    { value: 'hero_android_twa_data', label: 'Android TWA Data' },
    { value: 'hero_flame_feed', label: 'Flame Feed' },
    // Deprecated storage keys
    { value: 'iosData', label: 'Old iOS Data' },
    { value: 'androidData', label: 'Old Android Data' },
  ],
});
